export default {"src":"/_next/static/media/money-white.9d439909.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};